import { Edit3, Loader2, Plus, RefreshCw, Trash2 } from "lucide-react";
import type { RequisitoLegalControlModificacion } from "../types/requisitos-legales";

type Props = {
  rows: RequisitoLegalControlModificacion[];
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  onCreate: () => void;
  onEdit: (row: RequisitoLegalControlModificacion) => void;
  onDelete: (row: RequisitoLegalControlModificacion) => void;
};

export function RequisitosLegalesControlModificacionesTable({
  rows,
  loading,
  error,
  onRetry,
  onCreate,
  onEdit,
  onDelete,
}: Props) {
  return (
    <section className="reqleg-panel">
      <div className="reqleg-panel-toolbar">
        <div>
          <div className="calidad-toolbar-eyebrow">Documento</div>
          <h3 className="calidad-toolbar-title">
            Control documental
          </h3>
        </div>

        <div className="calidad-toolbar-meta">
          <span className="calidad-toolbar-count">
            {loading ? "Cargando..." : `${rows.length} registros`}
          </span>
          <button type="button" onClick={onCreate} className="calidad-primary-button">
            <Plus size={16} />
            Nuevo
          </button>
        </div>
      </div>

      {error ? (
        <div className="calidad-feedback-state reqleg-feedback-compact">
          <div className="calidad-feedback-title">No se pudo cargar la tabla</div>
          <p className="calidad-feedback-copy">{error}</p>
          <button type="button" onClick={onRetry} className="calidad-feedback-action">
            <RefreshCw size={15} />
            Reintentar
          </button>
        </div>
      ) : loading ? (
        <div className="calidad-feedback-state reqleg-feedback-compact">
          <Loader2 size={20} className="animate-spin text-[#0b4a2f]" />
          <div className="calidad-feedback-title">Cargando modificaciones</div>
        </div>
      ) : rows.length === 0 ? (
        <div className="calidad-feedback-state reqleg-feedback-compact">
          <div className="calidad-feedback-title">No hay modificaciones registradas</div>
          <button type="button" onClick={onCreate} className="calidad-primary-button">
            <Plus size={16} />
            Nuevo
          </button>
        </div>
      ) : (
        <div className="reqleg-table-scroll reqleg-control-scroll">
          <table className="calidad-table reqleg-table min-w-full">
            <thead>
              <tr>
                <th className="reqleg-actions-col">Acciones</th>
                <th className="reqleg-date-col">Fecha</th>
                <th>Modificaciones realizadas</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td className="reqleg-actions-col">
                    <div className="calidad-table-actions-row">
                      <button
                        type="button"
                        onClick={() => onEdit(row)}
                        className="calidad-icon-button"
                        title="Editar modificación"
                        aria-label="Editar modificación"
                      >
                        <Edit3 size={15} />
                      </button>
                      <button
                        type="button"
                        onClick={() => onDelete(row)}
                        className="calidad-icon-button danger"
                        title="Eliminar modificación"
                        aria-label="Eliminar modificación"
                      >
                        <Trash2 size={15} />
                      </button>
                    </div>
                  </td>
                  <td className="reqleg-date-col">{row.fecha}</td>
                  <td>{row.modificaciones_realizadas}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
